import { useRecoilValue } from "recoil"

import type { RetiredImageryStatus } from "~/components/RetiredImagery/useRetiredImageryStatus"
import { useRetiredImageryStatus } from "~/components/RetiredImagery/useRetiredImageryStatus"
import { designLocalState } from "~/containers/Proposal/state/designs/design-state"
import {
  safeSiteImageryState,
  siteRemoteState,
} from "~/containers/Proposal/state/site/site-state"

/** Whether the open Design's saved Bing image can still be shown in the Legacy Designer. */
export const useLegacyRetiredImageryStatus = (): {
  status: RetiredImageryStatus
  isReplacement: boolean
  retry: () => void
} => {
  const design = useRecoilValue(designLocalState)
  const site = useRecoilValue(siteRemoteState)
  const imagery = useRecoilValue(safeSiteImageryState)
  const [savedImage] = imagery
    .filter(({ source }) => source === design.displayImageryProvider)
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    )

  return useRetiredImageryStatus({
    source: design.displayImageryProvider,
    imageUrl: savedImage?.filename || null,
    ready: Boolean(design.id && site.id),
    isAurora: design.source === `aurora`,
  })
}
